import {library, dom, config} from '@fortawesome/fontawesome-svg-core';

import {
    faAngleLeft as faAngleLeftLight,
    faAngleRight as faAngleRightLight,
    faAnglesLeft as faAnglesLeftLight,
    faAnglesRight as faAnglesRightLight
} from '@fortawesome/pro-light-svg-icons';

import {
    faStar as faStarRegular,
    faEye as faEyeRegular,
    faEyeSlash as faEyeSlashRegular
} from '@fortawesome/pro-regular-svg-icons';

import {
    faVideo as faVideoRegular,
    faArrowUpFromBracket as faArrowUpFromBracketRegular
} from '@fortawesome/pro-regular-svg-icons';

import {
    fa360Degrees,
    faAngleDown,
    faAngleLeft,
    faAngleRight,
    faAngleUp,
    faAngleDoubleRight,
    faAnglesLeft,
    faAnglesRight,
    faArrowLeft,
    faArrowLeftLong,
    faArrowRight,
    faArrowRotateLeft,
    faArrowTurnDownRight,
    faArrowsRotate,
    faBackwardFast,
    faBan,
    faBars,
    faBasketShoppingSimple,
    faBoltLightning,
    faBook,
    faBookOpenCover,
    faBoxTaped,
    faBoxOpenFull,
    faCalendarClock,
    faBoxOpen,
    faCalendarDays,
    faCampground,
    faCaretDown,
    faCaretRight,
    faCartCircleCheck,
    faCartPlus,
    faCartShopping,
    faCashRegister,
    faCheck,
    faChevronLeft,
    faChevronRight,
    faCircle,
    faCircleCheck,
    faCircleInfo,
    faCirclePlus,
    faCircleQuestion,
    faCircleXmark,
    faComment,
    faCoins,
    faClapperboardPlay,
    faDownload,
    faCreditCard,
    faEnvelope,
    faEnvelopeOpenText,
    faEraser,
    faEuroSign,
    faEye,
    faEyeSlash,
    faSterlingSign,
    faChfSign,
    faFileLines,
    faForwardFast,
    faGift,
    faGiftCard,
    faGlobe,
    faHashtag,
    faHeart,
    faHouse,
    faHandHoldingCircleDollar,
    faIdCard,
    faLocationArrow,
    faLocationDot,
    faLock,
    faMagnifyingGlass,
    faMagnifyingGlassPlus,
    faMinus,
    faPause,
    faPen,
    faPenToSquare,
    faPlay,
    faPlus,
    faPrint,
    faReceipt,
    faRecycle,
    faRightLeft,
    faRotate,
    faRotateLeft,
    faShieldKeyhole,
    faSquareMinus,
    faSquarePlus,
    faStar,
    faStore,
    faStreetView,
    faTag,
    faThumbsUp,
    faTimesCircle,
    faTrash,
    faTruck,
    faTruckFast,
    faTruckFlatbed,
    faUpload,
    faUser,
    faWarehouseFull,
    faWrench,
    faXmark,
    faXmarkLarge,
    faEarthAmericas
} from '@fortawesome/pro-solid-svg-icons';

// TODO: jeweils die square oder nicht square version entfernen!
import {
    faFacebook,
    faSquareFacebook,
    faInstagram,
    faSquareInstagram,
    faYoutube,
    faSquareYoutube,
    faPinterest,
    faSquarePinterest,
} from '@fortawesome/free-brands-svg-icons';

import {
    faSpinnerThird,
} from '@fortawesome/pro-duotone-svg-icons'

library.add(
    // light
    faAngleLeftLight,
    faAngleRightLight,
    faEyeRegular,
    faEyeSlashRegular,
    faAnglesLeftLight,
    faAnglesRightLight,

    // regular
    faStarRegular,
    faVideoRegular,
    faArrowUpFromBracketRegular,

    // solid
    fa360Degrees,
    faAngleDown,
    faAngleLeft,
    faAngleRight,
    faAngleUp,
    faAngleDoubleRight,
    faAnglesLeft,
    faAnglesRight,
    faArrowLeft,
    faArrowLeftLong,
    faArrowRight,
    faArrowRotateLeft,
    faArrowTurnDownRight,
    faArrowsRotate,
    faBackwardFast,
    faBan,
    faBars,
    faBasketShoppingSimple,
    faBoltLightning,
    faBook,
    faBookOpenCover,
    faBoxTaped,
    faBoxOpenFull,
    faCalendarClock,
    faBoxOpen,
    faCalendarDays,
    faCampground,
    faCaretDown,
    faCaretRight,
    faCartCircleCheck,
    faCartPlus,
    faCartShopping,
    faCashRegister,
    faCampground,
    faCheck,
    faChevronLeft,
    faChevronRight,
    faCircle,
    faCircleCheck,
    faCircleInfo,
    faCirclePlus,
    faCircleQuestion,
    faCircleXmark,
    faComment,
    faCoins,
    faClapperboardPlay,
    faDownload,
    faCreditCard,
    faEnvelope,
    faEnvelopeOpenText,
    faEraser,
    faEuroSign,
    faEye,
    faSterlingSign,
    faChfSign,
    faEarthAmericas,
    faFileLines,
    faForwardFast,
    faTruckFlatbed,
    faGift,
    faGiftCard,
    faGlobe,
    faHashtag,
    faHeart,
    faHouse,
    faHandHoldingCircleDollar,
    faIdCard,
    faLocationArrow,
    faLocationDot,
    faLock,
    faMagnifyingGlass,
    faMagnifyingGlassPlus,
    faMinus,
    faPause,
    faPen,
    faPenToSquare,
    faPlay,
    faPlus,
    faPrint,
    faReceipt,
    faRecycle,
    faRightLeft,
    faRotate,
    faRotateLeft,
    faShieldKeyhole,
    faSquareMinus,
    faSquarePlus,
    faStar,
    faStore,
    faStreetView,
    faTag,
    faThumbsUp,
    faTimesCircle,
    faTrash,
    faTruck,
    faTruckFast,
    faUpload,
    faUser,
    faWrench,
    faWarehouseFull,
    faXmark,
    faXmarkLarge,

    // brands
    faFacebook,
    faSquareFacebook,
    faInstagram,
    faSquareInstagram,
    faYoutube,
    faSquareYoutube,
    faPinterest,
    faSquarePinterest,

    // duotone
    faSpinnerThird,
);

config.autoReplaceSvg = 'nest';

window.addEventListener('DOMContentLoaded', () => {
    dom.i2svg()
    dom.watch()
});
